// edit: zhangmyh 2017-6-23 3:33 PM
import { map } from 'lodash'
import urllist from './urllist'
/* global __ */

function getURLItem (items) {
  return items.map(function (item, i) {
    let title, url
    if (typeof item == 'string') {
      let urlobj = urllist[item]
      title = urlobj.title
      url = `../${urlobj.url}/index.${__('locale')}.html`
    } else if (typeof item == 'object') {
      let urlobj = urllist[item.id]
      title = urlobj.title
      url = `../${urlobj.url}/index.${__('locale')}.html`
      if (item.params) {
        let l = []
        map(item.params, function (v, k) {
          l.push(k + '=' + v)
        })
        if (l.length) {
          let p = l.join('&')
          url += '?' + p
        }
      }
    }
    return {
      text: title,
      url: (i) ? url : '',
      level: i
    }
  })
}

function breadcrumb (params) {
  this.titleList = getURLItem(params.path).reverse()
  // /yuncai/workbench#/pages/home/home
  let from = params.from || 'supply'
  this.home = `/cpu-supplymgr-fe/${(from == 'supply') ? 'supply_workbench0' : 'angang_workbench'}/index.${__('locale')}.html`
  // fix 暂时这么处理吧
  let location = window.location.href
  if (location.includes('www.ansteelscm.com')) {
  // 正式环境
    let user = JSON.parse(window.localStorage.getItem('user')).user.enterpriseId
    if (user == 186) {
      this.home = `/cpu-supplymgr-fe/angang_workbench/index.${__('locale')}.html`
    }
  } else if (location.includes('172.20.48.174')) {
  // 开发环境
    let user = JSON.parse(window.localStorage.getItem('user')).user.enterpriseId
    if (user == 978) {
      this.home = `/cpu-supplymgr-fe/angang_workbench/index.${__('locale')}.html`
    }
  } else if (location.includes('http://test.ansteelscm.com')) {
    // 测试环境
    let user = JSON.parse(window.localStorage.getItem('user')).user.enterpriseId
    if (user == 186) {
      this.home = `/cpu-supplymgr-fe/angang_workbench/index.${__('locale')}.html`
    }
  }
  this.homeText = __('index')
}

export default breadcrumb



// WEBPACK FOOTER //
// ./src/components/breadcrumbs/index.js